import React from "react";

const RightSideBarCounter = () => {
    return (
        <svg width="150" height="55" viewBox="0 0 150 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M143 7H0C0 3.13401 3.134 0 7 0H143V7Z" fill="#C9D7D8" />
            <rect x="132" y="18" width="132" height="11" transform="rotate(180 132 18)" fill="#4A5353" />
            <path d="M125 25H7C3.134 25 0 21.866 0 18H125V25Z" fill="#C9D7D8" />
            <path d="M143 0V55C146.866 55 150 51.866 150 48V7C150 3.13401 146.866 0 143 0Z" fill="#C9D7D8" />
            <path d="M132 7V55H143V7L132 7Z" fill="#4A5353" />
            <path d="M125 18V48C125 51.866 128.134 55 132 55V18H125Z" fill="#C9D7D8" />
        </svg>
    )
}
export default RightSideBarCounter;